import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../../firebase";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  updateProfile,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import Modal from "../../components/Modal/Modal"; // ✅ 모달 추가
import styles from "./Register.module.css";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  // 회원가입 처리
  const handleRegister = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      showModal("⚠️ 비밀번호가 일치하지 않습니다.");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      await updateProfile(user, { displayName: name });

      await setDoc(doc(db, "users", user.uid), {
        name: name,
        email: email,
        role: "user",
      });

      await sendEmailVerification(user);
      showModal("✅ 회원가입 성공! 이메일을 확인하고 인증하세요.", true);

      // 입력 필드 초기화
      setName("");
      setEmail("");
      setPassword("");
      setConfirmPassword("");
    } catch (error) {
      showModal(`❌ 회원가입 실패: ${error.message}`);
    }
  };

  // 모달 열기
  const showModal = (message, redirectToLogin = false) => {
    setModalMessage(message);
    setIsModalOpen(true);

    if (redirectToLogin) {
      setTimeout(() => {
        closeModal();
        navigate("/login");
      }, 2000);
    }
  };

  // 모달 닫기
  const closeModal = () => {
    setModalMessage("");
    setIsModalOpen(false);
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>회원가입</h2>
      <form onSubmit={handleRegister} className={styles.form}>
        <div className={styles.inputGroup}>
          <input
            type="text"
            className={styles.input}
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            placeholder=" "
          />
          <label>이름</label>
        </div>

        <div className={styles.inputGroup}>
          <input
            type="email"
            className={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder=" "
          />
          <label>이메일</label>
        </div>

        <div className={styles.inputGroup}>
          <input
            type="password"
            className={styles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder=" "
          />
          <label>비밀번호</label>
        </div>

        <div className={styles.inputGroup}>
          <input
            type="password"
            className={styles.input}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            placeholder=" "
          />
          <label>비밀번호 확인</label>
        </div>

        <button type="submit" className={styles.button}>
          회원가입
        </button>
      </form>

      {/* 모달 추가 */}
      {isModalOpen && <Modal message={modalMessage} onClose={closeModal} />}
    </div>
  );
};

export default Register;
